import {getCustomerOffer} from "@project/sdk/sales";
import {GetCustomerOfferResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";
import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {customerOfferKeys} from "../../../customerOffer-keys";
import {assertCustomerOfferDocument} from "../../../customerOffer-read";

export function getCustomerOfferQueryOptions(id: string) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: customerOfferKeys.detail(id),
    queryFn: async ({signal}) => {
      const response = await getCustomerOffer(id, {signal});
      const parsed = GetCustomerOfferResponse.parse(response);
      assertCustomerOfferDocument(parsed, response);
      return parsed;
    },
  });
}
